@import '~style-sheet-helpers/core.less';

.marketplace-usernames-wrapper {
  width: 500px;
  height: 300px;
  overflow: auto;
}

.marketplace-usernames-wrapper-background {
  position: fixed;
  inset: 0;
  background: transparent;
}

.marketplace-usernames-modal {
  width: calc(100% - 120px);
  height: 100%;
  overflow: hidden;
  margin-right: auto;
  margin-left: auto;
}

.marketplace-usernames-modal-body {
  padding: 15px;
  height: 100%;
}

.cancel-button {
  cursor: pointer;
}
